<template>
  <el-row class="login">
    <el-col :xs="24" :lg="12" >
      <div class="login__logo">
        <img class="login__logo--img" :src="logo"/>
      </div>
      <slot></slot>
    </el-col>
    <el-col :lg="12" class="login__background">
      <div class="login__background__text">
        <h1 class="login__background__text__title">
          {{ $t('layout.login.imageTitle') }}
        </h1>
        <h3 class="login__background__text__subtitle">
          {{ $t('layout.login.imageSubtitle') }}
        </h3>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import logoNextories from '@/assets/img/logo-nextories.png';

export default {
  name: 'loginLayout',
  computed: {
    logo() {
      return logoNextories;
    },
  },
};
</script>

<style scoped lang="scss">

  .login {
    display: flex;
    flex-direction: row;
    height: 100%;
    &__logo {
      &--img {
        height: 60px;
        margin: 20px 40px;
      }
    }
    &__background {
      display: none;
      position: relative;
      background-image: url('../../assets/img/demenagement.jpg');
      background-repeat:no-repeat;
      background-size: cover;
      text-align: center;
      background-position: center;
      @include breakpoint(wide) {
        display: block;
      }
      &__text {
        margin-top: 12rem;
        padding: 0 8rem;
        &__title {
          font-weight: 700;
          font-size: 50px;
          color: var(--nxt-color-white);
        }
        &__subtitle {
          font-weight: 500;
          font-size: 25px;
          color: var(--nxt-color-white);
        }
      }
    }
  }
</style>
